import {Moment} from 'moment';
import {ICustomer} from './customer.model';
import {ITransaction} from './transaction.model';
import {IFileObject} from "./file-object.model";
import {IOrganization} from "./organization.model";
import {IPhone} from "./phone.model";
import {IKala} from "./kala.model";
import {IOrderItems} from "./orderItems.model";
import {IEmployee} from "./employee.model";

export interface IOrder {
  id?: number;
  title?: string;
  startDate?: Moment;
  customer?: ICustomer;
  itemName?: string;
  code?: string;
  address?: string;
  audience?: string;
  type?: string;
  step?: Number;

  audience_phone?: string;
  phone?: IPhone;
  status?: string;
  closed?: any;
  stock_status?: string;
  require_finance_approval?: boolean;
  salesConfirmedBy?: string;
  salesConfirmedAt?: any;
  financeApprovedBy?: string;
  financeApprovedAt?: any;
  warehouseIssuedBy?: string;
  warehouseIssuedAt?: any;
  phone_id?: string;
  strDateObject?: any;
  strDateObject2?: any;
  porsant?: any;
  taxation?: string;
  discount?: string;
  total_sum?: any;
  factor_number?: string;
  factor_amount?: string;
  factor_amount_number?: number;
  factor_type?: string;
  factor_payment_method?: string;
  store_number?: string;
  store_responsible?: string;
  send_method?: string;
  employee_str?: any;
  payment_description?: string;
  payment_method?: string;
  address_receiver?: string;
  send_bill_number?: string;
  return_order_date?: any;
  send_order_date?: any;
  send_order_date_str?: string;
  return_order_date_str?: string;
  lastModifiedDate?: any;
  last_modified_date?: any;
  created_date?: any;

  updateDate?: string;
  description?: string;
  createdDate?: any;
  createdBy?: string;
  lastModifiedBy?: string;
  transactions?: ITransaction[];
  files?: IFileObject[];
  orderItems?: IOrderItems[];
  employee?: IEmployee;
  organization?: IOrganization;

}

export class Order implements IOrder {
  constructor(public id?: number,
              public title?: string,
              public step?: Number,
              public description?: string,
              public factor_number?: string,
              public factor_amount?: string,
              public factor_amount_number?: number,
              public factor_type?: string,
              public startDate?: Moment,
              public customer?: ICustomer,
              public phone?: IPhone,
              public createdBy?: string,
              public lastModifiedBy?: string,
              public closed?: boolean,
              public taxation?: any,
              public total_sum?: any,
              public discount?: any,
              public lastModifiedDate?: any,
              public transactions?: ITransaction[],
              public kala?: IKala[],
              public createdDate?: any) {
    this.total_sum = 0;
    this.factor_amount_number = 0;
  }
}
